import { Component, OnInit } from '@angular/core';
import { ADN_PLUS, TimelineItem } from '../../models';
import { CtrlBaseComponent } from '../ctrl-base.component';

@Component({
  selector: 'ct-timeline',
  templateUrl: './ct-timeline.component.html',
  styleUrls: ['./ct-timeline.component.css']
})
export class CtTimelineComponent extends CtrlBaseComponent {

  titleField: string;
  textField: string;
  iconField: string;
  dateField: string;
  emptyMessage: string;
  timelineItems: TimelineItem[] = []
  title: string;
  subTitle: string;

  adnList: ADN_PLUS[] = [];

  constructor() { super() }

  convertAnListToTimelineItem() {
    if (!this.adnList || this.adnList.length == 0) return;
    this.timelineItems = [];
    for (let adn of this.adnList) {
      adn = new ADN_PLUS(adn);
      let tlItem = new TimelineItem();
      tlItem.title = adn.getStringAttribute(this.titleField)
      tlItem.text = adn.getStringAttribute(this.textField)
      tlItem.time = adn.getStringAttribute(this.dateField)
      tlItem.icon = adn.getStringAttribute(this.iconField)
      this.timelineItems.push(tlItem)
    }
  }

  setTitleField(titleField: string) { this.titleField = titleField }
  setTextField(textField: string) { this.textField = textField }
  setIconField(iconField: string) { this.iconField = iconField }
  setDateField(dateField: string) { this.dateField = dateField }
  setEmptyMessage(emptyMessage: string) { this.emptyMessage = emptyMessage }
  setAdnList(adnList: ADN_PLUS[]) { this.adnList = adnList }

  getTitleField() { return this.titleField }
  getTextField() { return this.textField }
  getIconField() { return this.iconField }
  getDateField() { return this.dateField }
  getEmptyMessage() { return this.emptyMessage }
  getAdnList() { return this.adnList }
}
